import { Table } from 'app/components/table/table';
import { ITableColumn, TableModel } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { AgenturModel } from 'app/models/agentur.model';
import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';

export const AgenturVblListe = observer(() => {
	const { agenturListUiStore, berichteUiiStore } = useStore();

	const tm = useMemo(() => {
		const tm = new TableModel<AgenturModel, number>();
		const cols: ITableColumn<AgenturModel, number>[] = [
			{
				label: 'VTNR',
				path: 'agtId',
			},
			{
				label: 'Agentur',
				path: 'name',
			},
			{
				label: 'VD',
				path: 'vdId',
			},
			{
				label: 'GS',
				path: 'gsId',
			},
			{
				label: 'VBL',
				path: 'VBL.name',
				sortBy: 'VBL.lastName',
			},
			{
				label: 'VBL Bensl',
				path: 'VBL.bensl',
			},
			{
				label: 'VBL E-Mail',
				path: 'VBL.email',
			},
		];
		tm.setCols(cols);
		tm.sortBy = 'name';
		tm.idProperty = 'agtId';
		tm.idType = 'number';
		return tm;
	}, []);

	useEffect(() => {
		agenturListUiStore.load().then(() => {
			let res = agenturListUiStore.applyFilter(agenturListUiStore.items, { ignoreAgtId: true });
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				res = res.filter((a) => a.agtId === agtId);
			}
			tm.setRowData(res);
		});
	}, [tm, agenturListUiStore, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged]);

	return (
		<>
			<div className="table-container">
				<Table tm={tm} stickyHeader={true} allowCsvExport={true} csvExportName="agentur-vbl.csv"></Table>
			</div>
		</>
	);
});
